import { constantRoutes } from '@/router'
import Home from '../../components/common/Home.vue'
import { buildRouteMeta } from './route-meta'
import { ROUTE_SOURCE_V2, isFullCatalogRouteSource, selectV2RouteTree } from '@/router/iam-v2-route-source'
const _import = require('./router/_import_' + process.env.NODE_ENV)

const state = {
  routes: [],
  addRoutes: [],
  loaded: false,
  routeSource: '',
  routeError: null
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
    state.loaded = true
  },
  SET_ROUTE_SOURCE: (state, source) => { state.routeSource = source },
  SET_ROUTE_ERROR: (state, error) => {
    state.routeError = error
    if (error) {
      state.loaded = false
      state.addRoutes = []
      state.routes = constantRoutes.slice()
    }
  },
  RESET_ROUTES: state => {
    asyncRoutes = []
    state.addRoutes = []
    state.routes = constantRoutes.slice()
    state.loaded = false
    state.routeSource = ''
    state.routeError = null
  }
}

let asyncRoutes = []

export function formatRoutes (res) {
  for (let r of res) {
    if (r.path === '/dashboard' || r.component === 'dashboard/index') r.title = '业绩排行'
    if (r.code === 'route.order_list_data') r.title = '订单列表'
    if (r.code === 'route.performance_data' || r.code === 'route.performace_list_data') r.title = '业绩列表'
    if (r.component === 'Home') r.component = Home
    else r.component = _import(r.component)
    r.meta = buildRouteMeta(r)
    if (r.children) formatRoutes(r.children)
  }
  return res
}

function getV2Routes (rootState) {
  const access = rootState.access || {}
  if (access.status !== 'ready' || !access.snapshot || !isFullCatalogRouteSource(access.snapshot)) {
    const error = new Error('权限路由尚未启用')
    error.code = 'IAM_V2_ROUTE_SOURCE_REQUIRED'
    throw error
  }
  return formatRoutes(selectV2RouteTree(access.snapshot.routes))
}

const actions = {
  async generateRoutes ({ commit, rootState }) {
    commit('SET_ROUTE_SOURCE', ROUTE_SOURCE_V2)
    commit('SET_ROUTE_ERROR', null)
    try {
      asyncRoutes = getV2Routes(rootState)
    } catch (error) {
      asyncRoutes = []
      commit('SET_ROUTE_ERROR', {
        code: String((error && error.code) || 'ROUTE_SOURCE_UNAVAILABLE'),
        message: String((error && error.message) || error || '路由加载失败')
      })
      throw error
    }
    commit('SET_ROUTES', asyncRoutes)
    return asyncRoutes
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/permission.js